import { useInfiniteQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { AnimalDto } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useGetAnimalList(scope: string = 'animalList', params: any = {}, cacheTime = 1000 * 60 * 5) {
  const { userFarm: farmId } = useAuth()

  return useInfiniteQuery<AnimalDto, Error>({
    queryKey: [scope, params],
    queryFn: async ({ pageParam }) => {
      return animalController.getAnimalListByFarmId(farmId!, {
        ...params,
        tokenPage: pageParam
      })
    },
    initialPageParam: null,
    enabled: !!farmId,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    staleTime: cacheTime,
    retry: 5,
    getNextPageParam: (lastAnimalListRequest?: AnimalDto) => {
      return lastAnimalListRequest?.nextPage ?? null
    }
  })
}
